import { render, staticRenderFns } from "./ForbiddenKeywordsTab.vue?vue&type=template&id=072119af&scoped=true"
import script from "./ForbiddenKeywordsTab.vue?vue&type=script&lang=js"
export * from "./ForbiddenKeywordsTab.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenKeywordsTab.vue?vue&type=style&index=0&id=072119af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072119af",
  null
  
)

export default component.exports